module.exports = __webpack_public_path__ + "static/media/reportCxcPercentage.498f841f.svg";